import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export default function Client() {
  const clients = [
    { logo: "/assets/BASF-Logo.png", name: "BASF" },
    { logo: "/assets/Logo_Areva.svg", name: "Areva" },
    { logo: "/assets/Technip.svg", name: "Technip" },
    { logo: "/assets/Samsung_Logo.svg", name: "Samsung" },
    { logo: "/assets/Thyssenkrupp_AG_Logo_2015.svg.png", name: "Thyssenkrupp" },
    { logo: "/assets/MMG_Logo_RED.jpg", name: "MMG" },
  ];

  return (
    <div className="pt-6">

      {/* ================= HERO ================= */}
      <section className="text-center py-12 bg-blue-50 dark:bg-gray-800 transition-colors">
        <h1 className="text-3xl sm:text-4xl font-bold text-blue-600 dark:text-white mb-4">
          Our Clients
        </h1>
        <p className="max-w-2xl mx-auto text-gray-700 dark:text-blue-100 opacity-90">
          Trusted by leading companies and organizations across multiple
          industries. Here are some of the amazing partners we’ve worked with.
        </p>
      </section>

      {/* ================= CLIENT SLIDER ================= */}
      <section className="py-20 bg-blue-50 dark:bg-blue-950 transition-colors">
        <div className="max-w-6xl mx-auto px-6">

          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            loop={true}
            autoplay={{
              delay: 2200,
              disableOnInteraction: false,
            }}
            breakpoints={{
              0: { slidesPerView: 2 },
              640: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 5 },
            }}
          >
            {clients.map((client, index) => (
              <SwiperSlide key={index}>
                <div className="flex justify-center">

                  {/* CARD PUTIH */}
                  <div
                    className="
                      bg-white
                      p-5 rounded-xl
                      shadow-md
                      transition-all duration-300
                      hover:shadow-xl
                      hover:scale-105
                    "
                  >
                    <img
                      src={client.logo}
                      alt={client.name}
                      className="h-14 object-contain"
                    />
                  </div>

                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="py-16 text-center bg-blue-50 dark:bg-gray-800 transition-colors">
        <h2 className="text-2xl sm:text-3xl font-bold text-blue-600 dark:text-white mb-4">
          Want to collaborate with us?
        </h2>
        <p className="mb-6 max-w-2xl mx-auto text-gray-700 dark:text-blue-100">
          Join our growing list of clients and partners to build a sustainable
          and innovative future together.
        </p>

        <a
          href="/contact"
          className="
            inline-block px-6 py-3
            bg-blue-600 text-white
            rounded-xl font-semibold shadow-md
            hover:scale-105 transition
          "
        >
          Contact Us
        </a>
      </section>

    </div>
  );
}
